import React, { cloneElement, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { removeUserToken } from "../store/slices/userTokenSlice";
import { startGamePlay } from "../http/http";
import MediumLoader from "./Loaders/MediumLoader";

const DailyGamePlayGate = ({ gameName, levelId, children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const [allowed, setAllowed] = useState(false);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [attemptId, setAttemptId] = useState(null);
    const requestKey = useRef(null);

    useEffect(() => {
        if (!levelId) {
            setAllowed(false);
            setLoading(false);
            setMessage("Please select a game level before playing.");
            return;
        }

        const currentKey = `${location.key}:${gameName}:${levelId}`;
        if (requestKey.current === currentKey) {
            return;
        }
        requestKey.current = currentKey;

        let active = true;
        setAllowed(false);
        setAttemptId(null);
        setMessage("");
        setLoading(true);
        startGamePlay(gameName, levelId, userToken)
            .then(response => {
                if (active) {
                    const id = response?.data?.result?.attemptId;
                    if (!Number.isSafeInteger(id) || id <= 0) {
                        throw new Error("Game attempt could not be created.");
                    }
                    setAttemptId(id);
                    setAllowed(true);
                }
            })
            .catch(error => {
                if (!active) {
                    return;
                }
                if (error?.response?.status === 403) {
                    dispatch(removeUserToken());
                    navigate("/", { replace: true });
                    return;
                }
                setMessage(
                    error?.response?.data?.error ||
                    "Unable to start this game. Please try again."
                );
            })
            .finally(() => {
                if (active) {
                    setLoading(false);
                }
            });

        return () => {
            active = false;
        };
    }, [dispatch, gameName, levelId, location.key, navigate, userToken]);

    if (loading) {
        return <MediumLoader />;
    }

    if (!allowed) {
        return (
            <main style={{ minHeight: "60vh", display: "grid", placeContent: "center", gap: "1rem", textAlign: "center", padding: "1.5rem" }}>
                <p role="alert">{message}</p>
                <button type="button" onClick={() => navigate("/home")}>Return to Home</button>
            </main>
        );
    }

    return React.isValidElement(children)
        ? cloneElement(children, { gameAttemptId: attemptId })
        : children;
};

export default DailyGamePlayGate;
